const DevelopmentOfAgriculture = require('./AgeA/DevelopmentOfAgriculture');
const DevelopmentOfCivilization = require('./AgeA/DevelopmentOfCivilization');
const DevelopmentOfCrafts = require('./AgeA/DevelopmentOfCrafts');
const DevelopmentOfMarkets = require('./AgeA/DevelopmentOfMarkets');
const DevelopmentOfPlanning = require('./AgeA/DevelopmentOfPlanning');
const DevelopmentOfPolitics = require('./AgeA/DevelopmentOfPolitics');
const DevelopmentOfReligion = require('./AgeA/DevelopmentOfReligion');
const DevelopmentOfScience = require('./AgeA/DevelopmentOfScience');
const DevelopmentOfSettlement = require('./AgeA/DevelopmentOfSettlement');
const DevelopmentOfTradeRoutes = require('./AgeA/DevelopmentOfTradeRoutes');
const DevelopmentOfWarfare = require('./AgeA/DevelopmentOfWarfare');
const Barbarians = require('./Age1/Barbarians');
const BorderConflict = require('./Age1/BorderConflict');
const CallToArms = require('./Age1/CallToArms');
const Crusades = require('./Age1/Crusades');
const CulturalInfluence = require('./Age1/CulturalInfluence');
const DarkAges = require('./Age1/DarkAges');
const Foray = require('./Age1/Foray');
const GoodHarvest = require('./Age1/GoodHarvest');
const Immigration = require('./Age1/Immigration');
const KnowledgeOfTheAncients = require('./Age1/KnowledgeOfTheAncients');
const NewDeposits = require('./Age1/NewDeposits');
const Pestilence = require('./Age1/Pestilence');
const Raiders = require('./Age1/Raiders');
const Rats = require('./Age1/Rats');
const Rebellion = require('./Age1/Rebellion');
const ReignOfTerror = require('./Age1/ReignOfTerror');
const ScientificBreakthrough = require('./Age1/ScientificBreakthrough');
const UncertainBorders = require('./Age1/UncertainBorders');
const ArmsIndustry = require('./Age2/ArmsIndustry');
const CivilUnrest = require('./Age2/CivilUnrest');
const ColdWar = require('./Age2/ColdWar');
const CrimeWave = require('./Age2/CrimeWave');
const EconomicProgress = require('./Age2/EconomicProgress');
const Emigration = require('./Age2/Emigration');
const FreedomOfMovement = require('./Age2/FreedomOfMovement');
const Iconoclasm = require('./Age2/Iconoclasm');
const IndependenceDeclaration = require('./Age2/IndependenceDeclaration');
const InternationalAgreement = require('./Age2/InternationalAgreement');
const InternationalNegotiations = require('./Age2/InternationalNegotiations');
const NationalPride = require('./Age2/NationalPride');
const PoliticsOfStrength = require('./Age2/PoliticsOfStrength');
const PopularizationOfScience = require('./Age2/PopularizationOfScience');
const Prosperity = require('./Age2/Prosperity');
const RavagesOfTime = require('./Age2/RavagesOfTime');
const Refugees = require('./Age2/Refugees');
const Terrorism = require('./Age2/Terrorism');
const ImpactOfAgriculture = require('./Age3/ImpactOfAgriculture');
const ImpactOfArchitecture = require('./Age3/ImpactOfArchitecture');
const ImpactOfBalance = require('./Age3/ImpactOfBalance');
const ImpactOfColonies = require('./Age3/ImpactOfColonies');
const ImpactOfCompetition = require('./Age3/ImpactOfCompetition');
const ImpactOfCulture = require('./Age3/ImpactOfCulture');
const ImpactOfGovernment = require('./Age3/ImpactOfGovernment');
const ImpactOfHappiness = require('./Age3/ImpactOfHappiness');
const ImpactOfHarmony = require('./Age3/ImpactOfHarmony');
const ImpactOfIndustry = require('./Age3/ImpactOfIndustry');
const ImpactOfPopulation = require('./Age3/ImpactOfPopulation');
const ImpactOfProgress = require('./Age3/ImpactOfProgress');
const ImpactOfScience = require('./Age3/ImpactOfScience');
const ImpactOfStrength = require('./Age3/ImpactOfStrength');
const ImpactOfTechnology = require('./Age3/ImpactOfTechnology');
const ImpactOfVariety = require('./Age3/ImpactOfVariety');
const ImpactOfWonders = require('./Age3/ImpactOfWonders');

module.exports = {
    DevelopmentOfAgriculture,
    DevelopmentOfCivilization,
    DevelopmentOfCrafts,
    DevelopmentOfMarkets,
    DevelopmentOfPlanning,
    DevelopmentOfPolitics,
    DevelopmentOfReligion,
    DevelopmentOfScience,
    DevelopmentOfSettlement,
    DevelopmentOfTradeRoutes,
    DevelopmentOfWarfare,
    Barbarians,
    BorderConflict,
    CallToArms,
    Crusades,
    CulturalInfluence,
    DarkAges,
    Foray,
    GoodHarvest,
    Immigration,
    KnowledgeOfTheAncients,
    NewDeposits,
    Pestilence,
    Raiders,
    Rats,
    Rebellion,
    ReignOfTerror,
    ScientificBreakthrough,
    UncertainBorders,
    ArmsIndustry,
    CivilUnrest,
    ColdWar,
    CrimeWave,
    EconomicProgress,
    Emigration,
    FreedomOfMovement,
    Iconoclasm,
    IndependenceDeclaration,
    InternationalAgreement,
    InternationalNegotiations,
    NationalPride,
    PoliticsOfStrength,
    PopularizationOfScience,
    Prosperity,
    RavagesOfTime,
    Refugees,
    Terrorism,
    ImpactOfAgriculture,
    ImpactOfArchitecture,
    ImpactOfBalance,
    ImpactOfColonies,
    ImpactOfCompetition,
    ImpactOfCulture,
    ImpactOfGovernment,
    ImpactOfHappiness,
    ImpactOfHarmony,
    ImpactOfIndustry,
    ImpactOfPopulation,
    ImpactOfProgress,
    ImpactOfScience,
    ImpactOfStrength,
    ImpactOfTechnology,
    ImpactOfVariety,
    ImpactOfWonders
}